import BqnContext from "common/BqnContext";
import { useContext, useEffect } from "react";
import { useNavigate} from 'react-router-dom';
import Dashboard from "./index";

export function DashboardSwitch() {
  const bqnContext = useContext(BqnContext);
  const bqns = bqnContext.bqns;
  const bqnId = bqnContext.bqnId;
  const navigate = useNavigate();

  useEffect(() => {
    if(!bqns || bqnId=== undefined){
      return;
    }

    if (bqns.length === 0 || bqnId !== "all") {
      if(bqns.length === 0){
        $('#dashboard-back-button').hide();
      }else{
        $('#dashboard-back-button').show();
      }
    }else{
      navigate('/viewClusterDashboard')
    }
  }, [bqnId, bqns]);

  if(bqns && bqnId !== undefined && (bqns.length === 0 || bqnId !== 'all')){
    return <Dashboard />
  }

  return null;
}
